import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@user/store'
import VueRouterMiddleware, { createMiddleware, middleware } from 'vue-router-middleware'

import { actionTypes, mutationTypes } from '@base/store/store-types'
import { getToken } from '@base/store'
import NotFoundPage from '@base/components/NotFoundPage.vue'
import SettingsView from '@base/views/SettingsView.vue'
import BasePage from '@user/views/BasePage.vue'
import SalesView from '@user/views/SalesView.vue'
import { webConfig } from '@base/configs'
import InstagramMediaView from '@base/views/InstagramMediaView'
import ProductSheetsView from '@user/views/ProductSheetsView.vue'
import ProductSheetDetailView from '@user/views/ProductSheetDetailView.vue'
import ProductSheetBaseView from '@user/views/ProductSheetBaseView.vue'
import ProductsView from '@user/views/ProductsView.vue'
import ProductSalesView from '@user/views/ProductSalesView.vue'

// Set marketId header to axios from session storage
const checkMarketId = (token) => {
  if (!store.state.marketId) {
    store.commit(mutationTypes.SET_MARKET_HEADER, token.marketId ? token.marketId : '')
  }
}

// Check if user can have an access to market
const checkMarketAccess = (next) => {
  const token = getToken('CustomerToken')
  if (!token.flexposApiValid || !token.salesAccess) {
    store.dispatch(actionTypes.LOGOUT_CUSTOMER)
  } else {
    next()
  }
}

const checkIndividualizedItemsAccess = (next) => {
  const token = getToken('CustomerToken')
  if (token.individualizedItemsAccess && token.flexposApiValid) {
    next()
  } else {
    next({ name: 'not-found' })
  }
}

createMiddleware('require-auth', (args, to, from, next) => {
  const token = getToken('CustomerToken')
  const urlAfterLogout = (token && token.marketId) ? `${webConfig.baseURL}/${token.marketId}` :
    webConfig.baseURL
  if (!store.state.user.isAuthenticated) {
    store.dispatch(actionTypes.INIT_USER, 'CustomerToken')
      .then(() => {
        if (!store.state.user.isAuthenticated) {
          store.dispatch(actionTypes.LOGOUT_CUSTOMER, urlAfterLogout)
        } else {
          if (!token || !token.accessToken) {
            store.dispatch(actionTypes.LOGOUT_CUSTOMER, urlAfterLogout)
            return
          }
          checkMarketId(token)
          next()
        }
      })
      .catch((error) => {
        if ((error.response && error.response.status === 401) ||
                    !store.state.user.isAuthenticated) {
          store.dispatch(actionTypes.LOGOUT_CUSTOMER, urlAfterLogout)
        } else {
          next()
        }
      })
  } else {
    next()
  }
})

createMiddleware('check-media-id', (args, to, from, next) => {
  store.dispatch(actionTypes.GET_MARKET_INSTAGRAM_MEDIA, to.params.mediaId)
    .then(() => {
      if (store.state.marketInstagramMedia) {
        if (!store.state.marketInstagramMedia.mediaId)
          next({ name: 'not-found' })
        else
          next()
      }
      else
        next({ name: 'not-found' })
    })
    .catch(() => {
      next({ name: 'not-found' })
    })
})

const routes = [
  ...middleware('require-auth', [{
    path: '/',
    name: 'base',
    component: BasePage,
    redirect: 'sales',
    children: [
      {
        path: 'sales',
        name: 'sales',
        beforeEnter: (to, from, next) => {
          checkMarketAccess(next)
        },
        component: SalesView,
      },
      {
        path: 'product-sheets',
        beforeEnter: (to, from, next) => {
          checkMarketAccess(next)
          checkIndividualizedItemsAccess(next)
        },
        component: ProductSheetBaseView,
        children: [
          {
            path: '',
            name: 'product-sheets',
            component: ProductSheetsView,
          },
          {
            path: ':productSheetId/detail',
            name: 'product-sheet-details',
            component: ProductSheetDetailView,
          },
          // Route for Product Sheet detail page
          {
            path: ':productSheetId/detail/:productId/sales',
            name: 'product-sheet-product-sale-lines',
            component: ProductSalesView,
          },
          // Route for Products page
          {
            path: ':productSheetId/products/:productId/sales',
            name: 'product-sale-lines',
            component: ProductSalesView,
          },
        ]
      },
      {
        path: 'products',
        name: 'products',
        beforeEnter: (to, from, next) => {
          checkMarketAccess(next)
          checkIndividualizedItemsAccess(next)
        },
        component: ProductsView,
      },
      {
        path: 'settings',
        name: 'settings',
        beforeEnter: (to, from, next) => {
          checkMarketAccess(next)
        },
        component: SettingsView,
      },
      ...middleware('check-media-id', [
        {
          path: 'post/loppeonline/:mediaId',
          name: 'media-page',
          component: InstagramMediaView,
        },
      ]),
    ]
  },
  ]),
  {
    path: '/404',
    name: 'not-found',
    component: NotFoundPage,
  },
  {
    path: '*',
    redirect: '/404'
  }
]

const router = new VueRouter({ routes })


Vue.use(VueRouter)
Vue.use(VueRouterMiddleware, { router })

export default router
